module.exports = __webpack_public_path__ + "img/plexus-7-smal.8051aff6.png";